import {
  TYPE_LOAD,
  TYPE_LOAD_SUCCESS,
  TYPE_ERROR,
  TYPE_SAVE,
  TYPE_SAVE_SUCCESS,
  TYPE_CLEAN,
  TYPE_DELETE,
  TYPE_DELETE_SUCCESS
} from "./actionTypes"

export const typeError = error => {
  return {
    type: TYPE_ERROR,
    payload: error,
  }
}
export const initLoadTypes = (concept) => {
  return {
    type: TYPE_LOAD,
    payload: concept,
  }
}
export const initDeleteTypes = (list) => {
  return {
    type: TYPE_DELETE,
    payload: list,
  }
}
export const deleteType = response => {
  return {
    type: TYPE_DELETE_SUCCESS,
    payload: { response },
  }
}
export const loadTypesSuccess = types => {
 
  return {
    type: TYPE_LOAD_SUCCESS,
    payload: types,
  }
}
export const saveType = type => {
  return {
    type: TYPE_SAVE,
    payload: { type },
  }
}
export const saveTypeSuccess = response => {
  return {
    type: TYPE_SAVE_SUCCESS,
    payload: { response },
  }
}
export const cleanType = () => {
  return {
    type: TYPE_CLEAN,
    payload: {},
  }
}
